import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY} from "@next/ux-fabric"
import {IN_STOCK, SOLD_OUT} from "../../../../config/constants"

export const PriceParentWrapper = styled("div")`
    white-space: nowrap;
    padding-right: 1rem;
`

export const StatusWrapper = styled("div")<{status: string}>`
    font-family: ${({theme}) => `${theme.uxfabric.global.body1.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    margin: 0.25rem 0 0 0;
    font-size: ${({theme}) => `${theme.uxfabric.global.body1.fontSize}`};
    font-weight: ${({theme}) => `${theme.uxfabric.global.body1.fontWeight}`};
    letter-spacing: ${({theme}) => `${theme.uxfabric.global.body1.letterSpacing}`};
    line-height: ${({theme}) => `${theme.uxfabric.global.body1.lineHeight}`};
    text-transform: ${({theme}) => `${theme.uxfabric.global.body1.textTransform}`};
    color: ${props => {
        switch (props.status) {
            case IN_STOCK:
                return props.theme.uxfabric.brand.success.stock.textColor
            case SOLD_OUT:
                return props.theme.uxfabric.brand.error.stock.textColor
            default:
                return props.theme.uxfabric.brand.warning.stock.textColor
        }
    }};
`

export const ProductDetails = styled("div")`
    width: 100%;

    && > p {
        font-family: ${({theme}) => `${theme.uxfabric.global.body1.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
        color: ${({theme}) => theme.uxfabric.text.secondary};
        word-break: break-all;
        padding-right: 0.613rem;
    }
`
export const ProductDetailItem = styled("div")`
    display: flex;
    justify-content: space-between;
    > h3:first-of-type {
        word-wrap: break-word;
        max-width: 10.3125rem;
        padding-right: 0.625rem;
    }
    > h3:last-child {
        white-space: nowrap;
    }
`
